import { isThemeToken } from '@nettbureau/theme';
import { isNumber } from 'radash';

/**
 * Parses a flex alignment or justification to its CSS value.
 *
 * @param value - The flex alignment or justification to normalize.
 */ function parseFlexAlignment(value) {
    return value === 'start' || value == 'end' ? `flex-${value}` : value;
}
/**
 * Parses a flex direction and order to its CSS value.
 *
 * @param direction - The flex direction.
 * @param reversed - Flag indicating if the order is reversed.
 */ function parseFlexDirection(direction, reversed) {
    return `${direction === 'vertical' ? 'column' : 'row'}${reversed ? '-reverse' : ''}`;
}
/**
 * Parses a spacing value to its CSS spacing representation based on the theme.
 *
 * @param theme - The theme object.
 * @param spacing - The spacing value or values to resolve.
 */ function parseGap(theme, gap) {
    return isNumber(gap) ? `${theme.scales.base * gap}px` : isThemeToken(gap, theme.gaps) ? `${theme.gaps[gap]}px` : gap;
}

export { parseFlexAlignment, parseFlexDirection, parseGap };
//# sourceMappingURL=flex.js.map
